import { cn, Text } from '@mntn/ui-components'

interface Props {
  text?: string
  prefix?: string
  className?: string
  variant?: 'dark'
}

export const TextCell = ({ text, prefix, className, variant }: Props) => {
  return (
    <Text
      variant="base-sm"
      inline
      className={cn('text-right text-primary m-0', variant === 'dark' && 'text-primary-inverse', className)}
    >
      {[prefix, text ?? '--'].join('')}
    </Text>
  )
}
